import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiChevronLeft, FiSearch, FiClock } from 'react-icons/fi';
import { ROUTES } from '../../app/routes';
import NaicsClassificationSearch from './NaicsClassificationSearch';
import NaicsClassificationHistory from './NaicsClassificationHistory';
import '../commissionscan/CommissionScan.css';
const NaicsClassificationPage: React.FC = () => {
    const navigate = useNavigate();
    const [view, setView] = useState<'search' | 'history'>('search');
    return (<div className="cs-page">
      <div className="cs-sidebar">
        <button className="cs-back-link" onClick={() => navigate(ROUTES.MARKETPLACE)}>
          <FiChevronLeft size={14}/>
          Back to Marketplace
        </button>
        <nav className="cs-nav">
          <button className={`cs-nav__item${view === 'search' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('search')}>
            <FiSearch size={15}/>
            Get NAICS Code
          </button>
          <button className={`cs-nav__item${view === 'history' ? ' cs-nav__item--active' : ''}`} onClick={() => setView('history')}>
            <FiClock size={15}/>
            History
          </button>
        </nav>
      </div>

      <div className={`cs-main${view === 'history' ? ' cs-main--history' : ''}`}>
        {view === 'history' ? (<NaicsClassificationHistory />) : (<NaicsClassificationSearch />)}
      </div>
    </div>);
};
export default NaicsClassificationPage;
